import { AssignSCBOneDevicesModal } from "../../components/configuration/AssignSCBOneDevicesModal";
import { UnassignSCBOneDevicesButton } from "../../components/configuration/UnassignSCBOneDevicesButton";

interface OrganizationSCBOneDeviceTableFooterProps {
  organizationId: string;
  selectedDeviceSerials: string[];
  onClearSelectedBeaconIds(): void;
}

export function OrganizationSCBOneDeviceTableFooter({
  organizationId,
  selectedDeviceSerials,
  onClearSelectedBeaconIds,
}: OrganizationSCBOneDeviceTableFooterProps) {
  return (
    <>
      <UnassignSCBOneDevicesButton
        organizationId={organizationId}
        selectedDeviceSerials={selectedDeviceSerials}
        onClearSelectedBeaconIds={onClearSelectedBeaconIds}
      />
      <AssignSCBOneDevicesModal organizationId={organizationId} />
    </>
  );
}
